import React from 'react';
import { ICategory } from '@/models';

interface Props {
  category: ICategory;
}

const Description: React.FC<Props> = ({ category }) => {
  if (!category.description) {
    return null;
  }

  return (
    <section className="section full section-y-md bg-sand-100">
      <div className="section-wrapper space-y-8">
        <h3 className="h3">{category.name}</h3>

        <p className="leading-snug">{category.description}</p>
      </div>
    </section>
  );
};

export default Description;
